import styled from 'styled-components'
import BooksitoutImages from '../../images/BooksitoutImages'

const TopnavLogo = () => {
	return (
		<Container href="/">
			<LogoImage src={BooksitoutImages.WebsiteLogo.booksitout} alt="booksitout-logo" />

			<div className="d-none d-md-block">
				<Space />
			</div>

			<div className="d-none d-md-block force-1-line">
				<LogoText>책잇아웃</LogoText>
			</div>
		</Container>
	)
}

const Container = styled.a.attrs(props => ({
	href: props.href,
	className: 'clickable',
}))`
	display: flex;
	align-items: center;

	&:hover {
		color: black;
	}
`

const LogoImage = styled.img.attrs({
	className: 'image-fluid',
})`
	width: 30px;
	height: 30px;
	border-radius: 8px;
`

const LogoText = styled.h1`
	font-size: 1.5rem;
	font-weight: 500;
	margin: 0;
	color: var(--text-color);
`

const Space = styled.div`
	padding-left: 5px;
	padding-right: 5px;
`

export default TopnavLogo
